// @flow
import { creativityMediaModel } from '../../../../../services/creativityMediaModel'

const productImage = require('./inedit.jpg')
const allTwoEs = require('./creativity1.jpg')
const allTwoCa = require('./creativity1.jpg')
const allFourEs = require('./creativity1.jpg')
const allFourCa = require('./creativity1.jpg')
const catalogTwoEs = require('./creativity1.jpg')
const catalogTwoCa = require('./creativity1.jpg')
const catalogFourEs = require('./creativity1.jpg')
const catalogFourCa = require('./creativity1.jpg')

const model = creativityMediaModel({ catalogID: 'beer', allTwoEs, allTwoCa, allFourEs, allFourCa, catalogTwoEs, catalogTwoCa, catalogFourEs, catalogFourCa })

type Params = {
  catalogID: string,
  numberOfColumns: number,
  language: string
}

export default {
  productImage,
  creativityMedia: (params: Params) => model[params.catalogID][params.numberOfColumns][params.language]
}
